import { SET_DEMO, UPDATE_TODAYS_INTAKE_DEMO, UPDATE_INTAKE_HISTORY_DEMO, UPDATE_INTAKE_DEMO } from "./actionTypes";

export const setDemo = (demoValue) => {
  return {
    type: SET_DEMO,
    payload: demoValue,
  };
};

export const updateTodaysIntakeDemo = (item) => {
  return {
    type: UPDATE_TODAYS_INTAKE_DEMO,
    payload: item,
  };
};

export const updateIntakeDemo = (item) => {
  return {
    type: UPDATE_INTAKE_DEMO,
    payload: item,
  };
};

export const setIntakeHistoryDemo = (item) => {
  return {
    type: UPDATE_INTAKE_HISTORY_DEMO,
    payload: item,
  };
};
